// shared/src/schemas/qa-question.ts
// Zod schema for `brief_qa_questions` table (DDL: 0009_qa_substrate.sql:21-38
// + 0033_qa_question_archive.sql adds `is_active`). 10 cols. Adds the missing
// Zod guard called out by audit-r3 S-002.
//
// Mirror of the QaQuestion TypeScript interface in shared/src/types/qa.ts:14-24;
// Zod schema added so schema-vs-ddl drift detection covers this table too.
//
// 2026-05-30: + is_active — 0033 added the column (archive feature) to the DDL +
// writer/reader but missed this schema, so the schema-vs-DDL drift detector
// failed. is_active is the archive flag (1=live, 0=archived).

import { z } from 'zod';

export const QaStatusEnum = z.enum(['idle', 'submitted', 'in_progress', 'updated', 'failed']);

export const QaQuestionSchema = z.object({
  id:                z.string(),
  question_text:     z.string(),
  created_at:        z.string().datetime(),
  updated_at:        z.string().datetime(),
  latest_status:     QaStatusEnum,
  latest_status_at:  z.string().datetime().nullable(),
  latest_brief_id:   z.string().nullable(),
  latest_error_msg:  z.string().nullable(),
  display_order:     z.number().int(),
  is_active:         z.number().int(),
});

export type QaQuestionRow = z.infer<typeof QaQuestionSchema>;
